(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-banner-premium"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('ultra-banner')) {

    class UltraBanner extends HTMLElement {

      connectedCallback() {

        if (this.initialized) return;

        this.initialized = true;
        this.abortController = new AbortController();

        const signal = this.abortController.signal;

        this.track = this.querySelector('[data-ultra-track]');
        this.viewport = this.querySelector('[data-ultra-viewport]');
        this.slides = Array.from(
          this.querySelectorAll('[data-ultra-slide]')
        );

        this.dots = Array.from(
          this.querySelectorAll('[data-ultra-dot]')
        );

        this.previousButton = this.querySelector('[data-ultra-prev]');
        this.nextButton = this.querySelector('[data-ultra-next]');
        this.toggleButton = this.querySelector('[data-ultra-toggle]');
        this.toggleLabel = this.querySelector(
          '[data-ultra-toggle-label]'
        );

        this.status = this.querySelector('[data-ultra-status]');

        this.currentIndex = Math.max(
          0,
          this.slides.findIndex(
            slide => slide.classList.contains('is-active')
          )
        );

        this.speed = Math.max(
          2000,
          Number.parseInt(this.dataset.speed, 10) || 4000
        );

        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';

        this.userPaused = false;
        this.hoverPaused = false;
        this.focusPaused = false;

        this.timer = null;
        this.touchStartX = null;

        this.motionQuery = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.reducedMotion = this.motionQuery.matches;
        this.designMode = Boolean(window.Shopify?.designMode);

        if (!this.track || this.slides.length === 0) {
          return;
        }

        this.bindEvents(signal);
        this.showSlide(this.currentIndex, false);

        this.classList.add('is-ready');
        this.scheduleAutoplay();

      }

      disconnectedCallback() {

        window.clearTimeout(this.timer);

        if (this.abortController) {
          this.abortController.abort();
        }

        if (
          this.motionQuery &&
          this.handleMotionChange
        ) {
          this.motionQuery.removeEventListener(
            'change',
            this.handleMotionChange
          );
        }

        this.initialized = false;

      }

      bindEvents(signal) {

        this.previousButton?.addEventListener(
          'click',
          () => {
            this.showSlide(this.currentIndex - 1, true);
            this.scheduleAutoplay();
          },
          { signal }
        );

        this.nextButton?.addEventListener(
          'click',
          () => {
            this.showSlide(this.currentIndex + 1, true);
            this.scheduleAutoplay();
          },
          { signal }
        );

        this.dots.forEach((dot) => {

          dot.addEventListener(
            'click',
            () => {
              const index = Number.parseInt(
                dot.dataset.index,
                10
              );

              this.showSlide(index, true);
              this.scheduleAutoplay();
            },
            { signal }
          );

        });

        this.toggleButton?.addEventListener(
          'click',
          () => {
            this.userPaused = !this.userPaused;
            this.updateToggleButton();
            this.scheduleAutoplay();
          },
          { signal }
        );

        this.addEventListener(
          'keydown',
          (event) => {

            const formElement = event.target.closest(
              'input, textarea, select'
            );

            if (formElement) return;

            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.showSlide(this.currentIndex - 1, true);
              this.scheduleAutoplay();
            }

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.showSlide(this.currentIndex + 1, true);
              this.scheduleAutoplay();
            }

          },
          { signal }
        );

        if (this.pauseOnHover) {

          this.addEventListener(
            'mouseenter',
            () => {
              this.hoverPaused = true;
              this.scheduleAutoplay();
            },
            { signal }
          );

          this.addEventListener(
            'mouseleave',
            () => {
              this.hoverPaused = false;
              this.scheduleAutoplay();
            },
            { signal }
          );

        }

        this.addEventListener(
          'focusin',
          () => {
            this.focusPaused = true;
            this.scheduleAutoplay();
          },
          { signal }
        );

        this.addEventListener(
          'focusout',
          () => {

            window.setTimeout(() => {

              this.focusPaused = this.contains(
                document.activeElement
              );

              this.scheduleAutoplay();

            }, 0);

          },
          { signal }
        );

        document.addEventListener(
          'visibilitychange',
          () => {
            this.scheduleAutoplay();
          },
          { signal }
        );

        this.viewport?.addEventListener(
          'pointerdown',
          (event) => {

            if (event.pointerType !== 'touch') return;

            this.touchStartX = event.clientX;

          },
          { signal }
        );

        this.viewport?.addEventListener(
          'pointerup',
          (event) => {

            if (
              event.pointerType !== 'touch' ||
              this.touchStartX === null
            ) {
              return;
            }

            const distance = this.touchStartX - event.clientX;

            if (Math.abs(distance) >= 50) {

              if (distance > 0) {
                this.showSlide(this.currentIndex + 1, true);
              } else {
                this.showSlide(this.currentIndex - 1, true);
              }

              this.scheduleAutoplay();

            }

            this.touchStartX = null;

          },
          { signal }
        );

        this.viewport?.addEventListener(
          'pointercancel',
          () => {
            this.touchStartX = null;
          },
          { signal }
        );

        document.addEventListener(
          'shopify:block:select',
          (event) => {

            const selectedSlide = event.target.closest(
              '[data-ultra-slide]'
            );

            if (
              !selectedSlide ||
              !this.contains(selectedSlide)
            ) {
              return;
            }

            const selectedIndex = this.slides.indexOf(
              selectedSlide
            );

            if (selectedIndex >= 0) {
              this.showSlide(selectedIndex, false);
            }

          },
          { signal }
        );

        this.handleMotionChange = (event) => {
          this.reducedMotion = event.matches;
          this.scheduleAutoplay();
        };

        this.motionQuery.addEventListener(
          'change',
          this.handleMotionChange
        );

      }

      showSlide(index, announceChange = false) {

        const total = this.slides.length;

        if (total === 0) return;

        this.currentIndex = (
          (index % total) + total
        ) % total;

        this.track.style.transform =
          `translate3d(-${this.currentIndex * 100}%, 0, 0)`;

        this.slides.forEach((slide, slideIndex) => {

          const isActive = slideIndex === this.currentIndex;

          slide.classList.toggle('is-active', isActive);
          slide.setAttribute(
            'aria-hidden',
            String(!isActive)
          );

          slide.inert = !isActive;

        });

        this.dots.forEach((dot, dotIndex) => {

          const isActive = dotIndex === this.currentIndex;

          dot.classList.toggle('is-active', isActive);

          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }

        });

        if (announceChange) {
          this.announceCurrentSlide();
        }

      }

      announceCurrentSlide() {

        if (!this.status) return;

        const currentSlide = this.slides[this.currentIndex];
        const title = currentSlide?.dataset.slideTitle?.trim();

        const message = title
          ? `Diapositiva ${this.currentIndex + 1} de ${this.slides.length}: ${title}`
          : `Diapositiva ${this.currentIndex + 1} de ${this.slides.length}`;

        this.status.textContent = '';

        window.requestAnimationFrame(() => {
          this.status.textContent = message;
        });

      }

      canAutoplay() {

        return (
          this.autoplayEnabled &&
          this.slides.length > 1 &&
          !this.userPaused &&
          !this.hoverPaused &&
          !this.focusPaused &&
          !this.reducedMotion &&
          !this.designMode &&
          !document.hidden
        );

      }

      scheduleAutoplay() {

        window.clearTimeout(this.timer);

        if (!this.canAutoplay()) return;

        this.timer = window.setTimeout(() => {

          this.showSlide(
            this.currentIndex + 1,
            false
          );

          this.scheduleAutoplay();

        }, this.speed);

      }

      updateToggleButton() {

        if (!this.toggleButton) return;

        const label = this.userPaused
          ? 'Reanudar carrusel'
          : 'Pausar carrusel';

        this.toggleButton.classList.toggle(
          'is-paused',
          this.userPaused
        );

        this.toggleButton.setAttribute(
          'aria-label',
          label
        );

        if (this.toggleLabel) {
          this.toggleLabel.textContent = label;
        }

      }

    }

    customElements.define(
      'ultra-banner',
      UltraBanner
    );

  }


  } catch(e) { console.error(e); }
})();
})();
